/**
 * @generated SignedSource<<9da6fd1a65ddaf135add9635021e0df4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssignPlaceholderAllocationsToPersonInput = {
  placeholderId?: string | null;
  personId?: string | null;
  isSoft?: boolean | null;
  placeholderAllocationIds?: ReadonlyArray<string | null> | null;
  deletePlaceholderIfEmpty?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type AssignPlaceholderAllocationsToPersonMutation$variables = {
  input: AssignPlaceholderAllocationsToPersonInput;
};
export type AssignPlaceholderAllocationsToPersonMutation$data = {
  readonly assignPlaceholderAllocationsToPerson: {
    readonly placeholderId: string | null;
    readonly deletedPlaceholderAllocationIds: ReadonlyArray<string | null> | null;
    readonly placeholderEmpty: boolean | null;
    readonly placeholderWasDeleted: boolean | null;
    readonly allocations: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly startYear: number | null;
        readonly startMonth: number | null;
        readonly startDay: number | null;
        readonly endYear: number | null;
        readonly endMonth: number | null;
        readonly endDay: number | null;
        readonly monday: number | null;
        readonly tuesday: number | null;
        readonly wednesday: number | null;
        readonly thursday: number | null;
        readonly friday: number | null;
        readonly saturday: number | null;
        readonly sunday: number | null;
        readonly description: string | null;
        readonly isProjectGroupAllocation: boolean | null;
        readonly projectGroupId: string | null;
        readonly projectGroupName: string | null;
        readonly projectGroupCompanyProjectGroupId: number | null;
        readonly projectGroupColor: string | null;
        readonly isSoft: boolean | null;
        readonly person: {
          readonly id: string;
        } | null;
        readonly project: {
          readonly id: string;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};
export type AssignPlaceholderAllocationsToPersonMutation = {
  variables: AssignPlaceholderAllocationsToPersonMutation$variables;
  response: AssignPlaceholderAllocationsToPersonMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssignPlaceholderAllocationsToPersonPayload",
    "kind": "LinkedField",
    "name": "assignPlaceholderAllocationsToPerson",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "placeholderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedPlaceholderAllocationIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "placeholderEmpty",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "placeholderWasDeleted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AllocationTypeEdge",
        "kind": "LinkedField",
        "name": "allocations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Allocation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "friday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sunday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isProjectGroupAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupCompanyProjectGroupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSoft",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignPlaceholderAllocationsToPersonMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignPlaceholderAllocationsToPersonMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "8b304c5ede5ac59d0e77169ea3be57de",
    "id": null,
    "metadata": {},
    "name": "AssignPlaceholderAllocationsToPersonMutation",
    "operationKind": "mutation",
    "text": "mutation AssignPlaceholderAllocationsToPersonMutation(\n  $input: AssignPlaceholderAllocationsToPersonInput!\n) {\n  assignPlaceholderAllocationsToPerson(input: $input) {\n    placeholderId\n    deletedPlaceholderAllocationIds\n    placeholderEmpty\n    placeholderWasDeleted\n    allocations {\n      node {\n        id\n        startYear\n        startMonth\n        startDay\n        endYear\n        endMonth\n        endDay\n        monday\n        tuesday\n        wednesday\n        thursday\n        friday\n        saturday\n        sunday\n        description\n        isProjectGroupAllocation\n        projectGroupId\n        projectGroupName\n        projectGroupCompanyProjectGroupId\n        projectGroupColor\n        isSoft\n        person {\n          id\n        }\n        project {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5567ccd3d2384e282d9da810e2739396";

export default node;
